'use client'

import { useProductCardContext } from '@/components/common/product-card/context/product-card-context'
import { ProductItemHeader } from '@/components/common/product-card/product-item-header'
import { ProductItemImages } from '@/components/common/product-card/product-item-images'
import { useTrackEvent } from '@/lib/gtm/track-event'
import { ETrackingEvent, TTrackingEcommerce } from '@/lib/gtm/type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'

export const ProductItemThumbnail = () => {
  const { product, selectedColorVariant } = useProductCardContext()

  const trackEvent = useTrackEvent<Partial<TTrackingEcommerce>>()

  const handleClick = () => {
    trackEvent({
      event: ETrackingEvent.SelectItem,
      ecommerce: {
        currency: 'VND',
        value: product.regular_price,
        items: [
          {
            item_id: product.id,
            item_name: product.title,
            price: product.regular_price,
            quantity: 1,
            item_brand: 'Coolmate',
            href: product.href,
            item_url: product.href,
            item_image: product.default_thumbnail,
            item_variant: selectedColorVariant.color,
            discount: product.sale_percent,
            item_rating: product?.review?.ratingValue,
          },
        ],
      },
    })
  }

  return (
    <div className='group relative'>
      <Link
        href={product.href}
        className='block h-full w-full'
        ga-tracking-value={`flash-sale__${product.id}`}
        ga-tracking-label={product.title}
        onClick={handleClick}
        aria-label={`View details for ${product.title}`}
      >
        <ProductItemImages />

        {!product?.icon_thumbnail?.hide && product?.icon_thumbnail?.image && (
          <div className='absolute bottom-0 left-0 z-[1] h-auto w-full rounded-b-lg'>
            <Image
              src={ImageHelper.getImageUrl(
                product?.icon_thumbnail?.image,
                '585_663'
              )}
              width={433}
              height={62}
              alt={`${product.title} thumbnail image`}
              className='block h-auto w-full rounded-b-lg object-cover'
              loading='lazy'
            />
          </div>
        )}
        <ProductItemHeader />
      </Link>
    </div>
  )
}
